import request from '@/utils/request';

// 获取功能列表
export function getVisualDevList(data) {
  return request({
    url: '/api/visualdev/Base',
    method: 'get',
    data: data
  });
}
// 获取功能信息
export function getVisualDevInfo(id) {
  return request({
    url: "/api/visualdev/Base/".concat(id),
    method: 'get'
  });
}

// 删除功能
export function Delete(id) {
  return request({
    url: "/api/visualdev/Base/".concat(id),
    method: 'DELETE'
  });
}
// 修改功能
export function Update(data) {
  return request({
    url: "/api/visualdev/Base/".concat(data.id),
    method: 'PUT',
    data: data
  });
}
// 新建功能
export function Create(data) {
  return request({
    url: '/api/visualdev/Base',
    method: 'post',
    data: data
  });
}
// 复制功能
export function Copy(id) {
  return request({
    url: "/api/visualdev/Base/".concat(id, "/Actions/Copy"),
    method: 'POST'
  });
}
// 获取模块命名
export function getAreasName() {
  return request({
    url: "/api/visualdev/Generater/AreasName",
    method: 'get'
  });
}
// 代码下载
export function DownloadCode(id, data) {
  return request({
    url: "/api/visualdev/Generater/".concat(id, "/Actions/DownloadCode"),
    method: 'POST',
    data: data
  });
}
// 代码预览
export function CodePreview(id, data) {
  return request({
    url: "/api/visualdev/Generater/".concat(id, "/Actions/CodePreview"),
    method: 'POST',
    data: data
  });
}
// 无表
// 获取列表表单配置JSON
export function getConfigData(modelId) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/Config"),
    method: 'get'
  });
}
// 获取列表配置JSON
export function getColumnData(modelId) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/ColumnData"),
    method: 'get'
  });
}
// 获取表单配置JSON
export function getFormData(modelId) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/FormData"),
    method: 'get'
  });
}
// 获取数据列表
export function getModelList(modelId, data) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/List"),
    method: 'post',
    data: data
  });
}
// 添加数据
export function createModel(modelId, data) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId),
    method: 'POST',
    data: data
  });
}
// 修改数据
export function updateModel(modelId, data) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/").concat(data.id),
    method: 'PUT',
    data: data
  });
}
// 获取数据信息
export function getModelInfo(modelId, id) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/").concat(id),
    method: 'GET'
  });
}
// 获取数据详情
export function getDataChange(modelId, id) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/").concat(id, "/DataChange"),
    method: 'GET'
  });
}
// 获取表单主表属性列表
export function getFormDataFields(modelId) {
  return request({
    url: "/api/visualdev/Base/".concat(modelId, "/FormDataFields"),
    method: 'GET'
  });
}
// 获取表单主表属性下拉框
export function getFieldDataSelect(modelId, data) {
  return request({
    url: "/api/visualdev/Base/".concat(modelId, "/FieldDataSelect"),
    method: 'GET',
    data: data
  });
}
// 删除数据
export function deteleModel(modelId, id) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/").concat(id),
    method: 'DELETE'
  });
}
// 批量删除数据
export function batchDelete(modelId, ids) {
  return request({
    url: "/api/visualdev/OnlineDev/batchDelete/".concat(modelId),
    method: 'post',
    data: {
      ids: ids
    }
  });
}
// 导出
export function exportModel(modelId, data) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/Actions/Export"),
    method: 'POST',
    data: data
  });
}
// 下载模板
export function getTemplate(modelId) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/Template"),
    method: 'GET'
  });
}
// 获取功能下拉框列表
export function getFeatureSelector(data) {
  return request({
    url: '/api/visualdev/Base/Selector',
    method: 'GET',
    data: data
  });
}
// App预览(后台APP表单设计)
export function Preview(data) {
  return request({
    url: "/api/visualdev/OnlineDev/App/Preview",
    method: 'post',
    data: {
      data: data
    }
  });
}
// 导出模板
export function exportData(modelId) {
  return request({
    url: "/api/visualdev/OnlineDev/".concat(modelId, "/Actions/ExportData"),
    method: 'post'
  });
}
// 导出App
export function exportAppData(modelId) {
  return request({
    url: "/api/visualdev/OnlineDev/App/".concat(modelId, "/Actions/ExportData"),
    method: 'post'
  });
}